import React, { useState, useEffect } from 'react';
import { useData } from '../context/DataContext';
import 'bootstrap/dist/css/bootstrap.min.css';

const Matchs = () => {
  const { 
    equipes, 
    matchs, 
    equipesLoading, 
    matchsLoading, 
    fetchEquipes, 
    fetchAllMatchs 
  } = useData();
  
  const [selectedEquipe, setSelectedEquipe] = useState('');

  useEffect(() => {
    const navbar = document.getElementById('navbar');
    if (navbar) {
      navbar.classList.add('page');
    }

    const loadData = async () => {
      // Charge les équipes d'abord
      await fetchEquipes();
    };

    loadData();
  }, [fetchEquipes]);

  // Quand les équipes sont chargées, sélectionner la première et charger tous les matchs
  useEffect(() => {
    if (equipes.length > 0) {
      if (!selectedEquipe) {
        setSelectedEquipe(equipes[0].liendivision);
      }
      // Charge tous les matchs une seule fois
      fetchAllMatchs(equipes);
    }
  }, [equipes, selectedEquipe, fetchAllMatchs]);

  const loading = equipesLoading || matchsLoading;

  return (
    <div className='container container-matchs'>
      <h1 className='text-center'>Matchs</h1>
      
    {Array.isArray(equipes) && equipes.length > 0 ? (
      <div className="form-group">
        <label className="col-sm-2 col-form-label">Équipes</label>
        <select
          className="form-control"
          value={selectedEquipe || ""}
          onChange={(e) => setSelectedEquipe(e.target.value)}
        >
          {equipes.map((equipe) => (
            <option key={equipe.liendivision} value={equipe.liendivision}>
              {equipe.libequipe}
            </option>
          ))}
        </select>
      </div>
    ) : (
      <p>Aucun match pour le moment.</p>
    )}

      {loading ? (
        <div className="text-center mt-4">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement en cours...</span>
          </div>
        </div>
      ) : (
        selectedEquipe && (
          <div className="mt-4">
            {matchs[selectedEquipe]?.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead className="thead-dark">
                    <tr>
                      <th>Date</th>
                      <th>Équipe A</th>
                      <th>Score A</th>
                      <th>Score B</th>
                      <th>Équipe B</th>
                    </tr>
                  </thead>
                  <tbody>
                    {matchs[selectedEquipe].map((match, index) => (
                      <tr key={`${match.idequipe}-${index}`}>
                        <td>{match.dateprevue}</td>
                        <td>{match.equa || 'AUCUNE EQUIPE'}</td>
                        <td>{match.scorea}</td>
                        <td>{match.scoreb}</td>
                        <td>{match.equb || 'AUCUNE EQUIPE'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-center">Aucun match.</p>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default Matchs;